import { STORAGE_KEY } from './state'

const localStoragePlugin = store => {
    store.subscribe((mutation, state) => {
        // console.log('store-subscribe')
        const syncedData = { auth: state.auth, user: state.user }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(syncedData))

        if (mutation.type === 'CLEAR_ALL_DATA') {
            console.log('remove-PortalStorage')
            localStorage.removeItem(STORAGE_KEY)
        }
    })
}

// TODO: setup env
// export default process.env.NODE_ENV !== 'production' ? [localStoragePlugin] : [localStoragePlugin]
export default [localStoragePlugin]



// WEBPACK FOOTER //
// ./src/store/plugins.js